module.exports = __webpack_public_path__ + "assets/img/structure-0edddb98.png";